import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  btnContainers: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  boxTitle: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  row: {
    position: 'relative',
    alignItems: 'center',
  },
  input: {
    width: '100%',
    color: 'rgb(0 0 0 / 87%)',
  },
  submitBtn: {
    fontSize: 12,
    whiteSpace: 'nowrap',
    fontWeight: 500,
    lineHeight: '26px',
    color: 'black',
    '&:hover': {
      color: 'black',
    },
  },
  icon: {
    color: 'green',
    position: 'absolute',
    fontSize: 40,
    zIndex: 1,
    top: 0,
    right: 0,
    transform: 'translate(52%, -48%)',
  },
  cardContainer: {
    position: 'relative',
    margin: '10px',
    // maxWidth: '300px',
    // display: 'flex',
    // justifyContent: 'center',
  },
  cardWrapper: {
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    cursor: 'pointer',
    maxWidth: '300px',
    width: '100%',
  },
  logoImage: {
    width: '80%',
    height: 'auto',
    maxHeight: '150px',
    objectFit: 'contain',
  },
  EndlogoImage: {
    width: '80%',
    height: '76px',
    maxHeight: '150px',
    objectFit: 'contain',
  },
  leftCol: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '24px',
    position: 'relative',
  },
  cardContent: {
    flex: '1',
    display: 'flex',
    alignItem: 'center',
    justifyContent: 'center',
  },

  page: {
    padding: '30px',
    background: '#f5f7fb',
    minHeight: '100vh',
  },
  heading: {
    fontSize: '34px',
    fontWeight: 700,
    marginBottom: '8px',
    color: '#111827',
  },
  subHeading: {
    color: '#6b7280',
    marginBottom: '30px',
  },
  card: {
    position: 'relative',
    borderRadius: '18px',
    padding: '10px',
    height: '180px',
    cursor: 'default',
    transition: '0.3s',
    border: '1px solid #e5e7eb',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  clickableCard: {
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
    },
  },
  oidcIcon: {
    position: 'absolute',
    left: 10,
    top: 10,
    width: 22,
    height: 22,
    borderRadius: '50%',
    background: '#ecfdf5',
    color: '#16a34a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fontSize: 15,
    },
  },
  approvedCard: {
    borderTop: '4px solid #22c55e',
  },
  noAccessCard: {
    borderTop: '4px solid #9ca3af',
    opacity: 0.85,
  },
  topIcon: {
    position: 'absolute',
    top: 16,
    right: 16,
    fontSize: 28,
  },
  approvedIcon: {
    color: '#22c55e',
  },
  deniedIcon: {
    color: '#9ca3af',
  },
  pendingIcon: {
    color: '#f59e0b',
  },
  appRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    marginTop: '25px',
  },
  appIcon: {
    width: '58px',
    height: '58px',
    objectFit: 'contain',
  },
  appInitial: {
    width: '58px',
    height: '58px',
    borderRadius: '12px',
    background: '#eef2ff',
    color: '#3730a3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: 700,
  },
  appName: {
    fontWeight: 700,
    fontSize: '20px',
    color: '#111827',
  },
  appDesc: {
    color: '#6b7280',
    fontSize: '14px',
    marginTop: '6px',
  },
  oidc: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: '22px',
    color: '#16a34a',
    fontWeight: 600,
    fontSize: '14px',
  },
  requestBtn: {
    marginTop: '22px',
    borderRadius: '10px',
    textTransform: 'none',
  },
}));
